import { AuthRegister, AuthLogin } from './Api'
export class Auth {
    forgotPassword(email) {

    }
    signOut() {

    }
    async signUp({ username, password, attributes }) {
        return await AuthRegister({ username, password, email: attributes.email });
    }

    async signIn({ username, password }) {
        return await AuthLogin({ email: username, password })
    }
}


